<script setup lang="ts">
import type { TransactionType } from '#shared/property/types';
import { TRANSACTION_TYPE_VALUES } from '#shared/property/types';
import type { PropertyOnList } from '#shared/property/api-types';

defineProps<{
  latestProperties: {
    sale: PropertyOnList[]
    rental: PropertyOnList[]
  }
}>();

const selectedTransactionType = ref<TransactionType>('sale');
</script>

<template>
  <IadWrapper
    tag="div"
    class="py-l md:py-2xl"
  >
    <IadTitle
      :text="$t('homepage.latest_properties')"
      variant="large"
      tag="h2"
      class="py-s md:py-m"
    />
    <IadRadioGroup v-model="selectedTransactionType">
      <IadRadio
        v-for="transactionTypeValue in TRANSACTION_TYPE_VALUES"
        :key="transactionTypeValue"
        :value="transactionTypeValue"
        :label="$t(`core.common.for.${transactionTypeValue}`)"
      />
    </IadRadioGroup>
    <IadScrollable
      variant="dense"
      :class="{
        '!hidden': selectedTransactionType === 'rental',
      }"
    >
      <PropertyCardPromo
        v-for="property of latestProperties.sale"
        :key="property.propertyListingRef"
        :property
      />
    </IadScrollable>
    <IadScrollable
      variant="dense"
      :class="{
        '!hidden': selectedTransactionType === 'sale',
      }"
    >
      <PropertyCardPromo
        v-for="property of latestProperties.rental"
        :key="property.propertyListingRef"
        :property
      />
    </IadScrollable>
  </IadWrapper>
</template>
